import { createSlice } from '@reduxjs/toolkit';
import { stateName } from './constants';
export const initialState = {
  isContentExpanded: false
};

const setPrivacyPolicyAccordionsExpanded = (draft, action) => {
  const {
    isExpanded
  } = action.payload;
  draft.isContentExpanded = isExpanded;
};

const PrivacyPolicyAccordionSlice = createSlice({
  name: stateName,
  initialState,
  reducers: {
    setPrivacyPolicyAccordionsExpanded
  }
});
export const {
  actions
} = PrivacyPolicyAccordionSlice;
export const plug = {
  [stateName]: PrivacyPolicyAccordionSlice.reducer
};
export default PrivacyPolicyAccordionSlice.reducer;